module.exports = __webpack_public_path__ + "img/logout.e434b6ad.svg";